<template>
    <l-layout class="l-chat-box" :bottom="200">
        <div class="l-rblock" style="background: #fff;overflow: auto;" ref="msgList">
            <div :class="['l-chat-box-msg-item',{'me':isMe(item)}]" v-for="(item,index) in value2" :key="index">
                <el-avatar :size="36" :src="avatar(item.f_SendUserId)" class="l-chat-box-avatar">
                    <img :src="`${rootUrl}img/admin/head.png`" />
                </el-avatar>
                <div class="l-chat-box-msg-title" v-if="!isMe(item)">{{getName(item.f_SendUserId)}}<span class="time">{{getTime(item.f_CreateDate)}}</span></div>
                <div class="l-chat-box-msg-title" v-else><span class="time">{{getTime(item.f_CreateDate)}}</span>{{getName(item.f_SendUserId)}}</div>
                <div class="l-chat-box-msg-content">
                    <div class="arrow"></div>
                    <div v-if="item.f_ChatMark != 2">
                        {{item.f_Content}}
                    </div>
                    <div v-else>
                        <div v-html="item.f_HtmlContent"></div>                        
                    </div>
                    <el-tooltip v-if="item.f_ChatMark != 1" effect="dark" content="复制" placement="bottom">
                            <el-button size="mini" circle @click="handleCopy(item)" icon="el-icon-copy-document"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="item.f_ChatMark != 1" effect="dark" content="分享" placement="bottom">
                            <el-button size="mini" circle @click="handleShare(item)" icon="el-icon-share"></el-button>
                        </el-tooltip>
                </div>
            </div>
        </div>
        <template #bottom>
            <l-layout v-loading="loading" :top="30" :topMove="false">
                <template #top>
                    <div class="l-rblock l-chat-box-bar">
                        <el-tooltip effect="dark" content="语音输入" placement="top">     
                            <el-button icon="el-icon-mic" @click="handleMic"></el-button>
                        </el-tooltip> 
                        <el-button v-if="savable" @click="$emit('save')" icon="el-icon-upload">保存对话</el-button>
                        <el-button icon="el-icon-time" @click="handleClear">清空对话</el-button>
                        <el-button v-if="closable" icon="el-icon-close" @click="$emit('close')" >关闭</el-button>
                    </div>
                </template>
                <textarea class="l-chat-box-textarea"                        
                          :placeholder="$t('请输入消息')"
                          v-model="msg"
                          @keyup.enter="sendChat">
                        </textarea>
            </l-layout>
        </template>
    </l-layout>
</template>
<script>

import MarkdownIt from 'markdown-it'

export default {
    name:'l-ai-chat-box',
    components: {

    },
    props: {
        value:[],
        closable:Boolean,
        savable:Boolean,
        platformId: String,
    },
    data () {
        return {
            msg: '',
            loading:false,
            md: new MarkdownIt(),
            platforms: []
        };
    },
    watch:{
        loading:{
            handler(val){
                this.$emit('loading', val)
            },
            immediate:true
        }
    },
    computed:{
        value2:{
            get(){
                return this.value;
            }
        }
    },
    mounted () {
        this.init()
    },
    methods:{
        async init(){
            window.$api.ai.platform.getList().then(res=>{
                this.platforms = res.data.data
            }).catch(error=>{
                this.$message.error(error)
            })
        },
        sendChat(){
            this.loading = true;
            var instanceId = this.$uuid()
            this.addChat(null, instanceId, this.loginInfo.f_UserId, this.msg, 0)
            var content = this.msg
            this.msg = ''
            var messageId = this.$uuid()
            this.addChat(messageId, instanceId, this.platformId, '正在思考中...', 1)
            const api = window.$api.ai.platform
            api.chat(this.platformId, { content }).then(res=>{
                this.addChat(messageId, instanceId, this.platformId, res.data, 2)
                this.loading = false;
            }).catch(error=>{
                console.log(typeof error)
                this.addChat(messageId, instanceId, this.platformId ,error.toString(), 2)
                this.loading = false;
            });
        },
        addChat(messaegId, instanceId, userId, msg, chatMark){
            messaegId = messaegId || this.$uuid()
            this.addMsg([{
                f_InstanceId: instanceId, //实例ID
                f_Id: messaegId,         //消息ID
                f_SendUserId: userId,       //用户ID
                f_Content: msg,             //内容
                f_HtmlContent: chatMark == 2 ? this.md.render(msg) : msg,
                f_CreateDate: new Date(),   //时间
                f_ChatMark: chatMark //0 问 1 思考中 2回复
            }])
        },
        addMsg(list){
            for(var item of list){
                var messageIndex = this.value.findIndex(t2=>item.f_Id ==t2.f_Id)
                if(messageIndex == -1){
                    this.value.push(item)
                }
                else{
                    this.$set(this.value, messageIndex, item)
                }
                this.$emit('change', item)
            }
            this.$nextTick(()=>{
                this.$refs.msgList.scrollTop = this.$refs.msgList.scrollHeight
            })            
        },
        handleMic(){

        },
        handleClear(){
            this.value.splice(0)
        },
        handleCopy(item){
            this.$copyText(item.f_Content).then(function () {
                alert('已复制')
            }, function () {
                alert('复制失败')
            })
        },
        handleShare(){
            alert('分享')
        },        
        isMe(item){
            if(item.f_SendUserId != this.loginInfo.f_UserId){
                return false
            }
            return true
        },
        getName(id){
            if(id == this.loginInfo.f_UserId){
                return '我'
            }
            var platform = this.platforms.find(t=>t.f_Id == id)
            if(platform){
                return platform.f_FullName+"●"+platform.f_ApiModelId;
            }
            return ''
        },
        getTime(time){
            time = time || new Date()
            const nowDate = this.$getDayTime('yyyy-MM-dd')
            const myDate = this.$formatDate(time,'yyyy-MM-dd')
            if(nowDate != myDate){
                return this.$formatDate(time,'yyyy-MM-dd HH:mm:ss')
            }
            else{
                return this.$formatDate(time,'HH:mm:ss')
            }
        },
        avatar(id){
            let user = null
            if(id == this.loginInfo.f_UserId){
                user = this.loginInfo
            }
            else{
                //user = this.lr_users[id]
            }

            if(user){
                return user.f_HeadIcon ? `${this.apiUrl}organization/user/img/${user.f_HeadIcon}?token=${this.token}` : `${this.rootUrl}img/admin/head.png`
            }
            return `${this.rootUrl}img/admin/head.png`
        },
    }
}
</script>